export default __webpack_public_path__ + "static/media/keyEscRed.331b05a6.svg";